module.exports = __webpack_public_path__ + "media/success_sweepstakes/girl-under-tree-ec417fe3.png";